import { render, staticRenderFns } from "./ktdwDetail.vue?vue&type=template&id=6ca1400f&scoped=true"
import script from "./ktdwDetail.vue?vue&type=script&lang=js"
export * from "./ktdwDetail.vue?vue&type=script&lang=js"
import style0 from "./ktdwDetail.vue?vue&type=style&index=0&id=6ca1400f&prod&lang=css"
import style1 from "./ktdwDetail.vue?vue&type=style&index=1&id=6ca1400f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca1400f",
  null
  
)

export default component.exports